export default "__VITE_ASSET__Cej7L3ul__"